(function (app) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Capture",
            {
                url: "/{transactionId}/Capture",
                template: "<ui-view />",
                resolve: {
                    transaction: ["transactionApi", "$transition$", function (transactionApi, $transition$) {
                        return transactionApi.get($transition$.params().transactionId);
                    }]
                },
                redirectTo: function(trans) {
                    return trans.injector().getAsync('transaction').then(function (transaction) {
                        return transaction.CapturePoints.length > 0
                            ? {
                                state: "Transaction.Capture." + transaction.CapturePoints[0],
                                params: { transactionId: transaction.Id }
                            }
                            : { state: "Transaction.Determine", params: { transactionId: transaction.Id } };
                    });
                }
            });
    }]);

})(window.app); //jshint ignore:line